<template>
  <!-- 根据角色获取列表 -->
  <el-menu
    :router="true"
    :unique-opened="true"
    :default-active="path"
    class="el-menu-vertical-demo"
    background-color="#fff"
    text-color="#555"
    active-text-color="#409eff"
    @select="handleOpen"
  >
    <label v-for="(item,index) in rightList" :key="item.id">
      <el-menu-item
        class="menu-first-link"
        v-if="item.children.length == 0"
        slot="title"
        :index="String(item.path)"
      >
        <i :class="item.navtabid"></i>
        <router-link
          style="display:inline-block;width:100%;height:100%;color:#555;"
          :to="item.path"
        >{{item.name}}</router-link>
      </el-menu-item>

      <el-submenu v-if="item.children.length != 0" :index="String(item.path)">
        <template slot="title">
          <i :class="item.navtabid"></i>
          <!-- <i v-if="index == 0" class="el-icon-menu"></i>
          <i v-else-if="index == 2" class="el-icon-info"></i>
          <i v-else-if="index == 5" class="el-icon-question"></i>
          <i v-else class="el-icon-location"></i> -->
          <span class="menu-first-link">{{item.name}}</span>
        </template>
        <el-menu-item v-for="item2 in item.children" :key="item2.id" :index="item2.path">
          <i :class="item2.navtabid"></i>
          <router-link class="menu-second-link" :to="item2.path">{{item2.name}}</router-link>
        </el-menu-item>
      </el-submenu>
    </label>
  </el-menu>
</template>

<script>
export default {
  data: function () {
    return {
      rightList: [

        {
          id: 2,
          name: '专题管理',
          path: '2',
          children: [
            {
              id: 2001,
              name: '列表',
              path: '/adminstrator/specaillist',
              children: []
            },
            {
              id: 2002,
              path: '/adminstrator/specialadd',
              name: '添加',
              children: []
            }
          ]
        },
        {
          id: 3,
          name: '专题分类管理',
          path: '/adminstrator/topicType',
          children: []
        },
        {
          id: 4,
          name: '员工管理',
          path: '/staff',
          children: [
            {
              id: 4001,
              name: '列表',
              path: '/staff/stafflist',
              children: []
            },
            {
              id: 4002,
              name: '添加编辑',
              path: '/staff/staffadd',
              children: []
            }
          ]
        },
        {
          id: 5,
          name: '标签管理',
          path: '/adminstrator/tag',
          children: []
        },
        {
          id: 6,
          name: '统计与记录',
          path: '',
          children: []
        },
        {
          id: 7,
          name: '公告管理',
          path: '/adminstrator',
          children: [
            {
              id: 4001,
              name: '列表',
              path: '/notice/notice',
              children: []
            },
            {
              id: 4002,
              name: '添加编辑',
              path: '/notice/noticeadd',
              children: []
            }
          ]
        },
        {
          id: 8,
          name: '公共信息文档管理',
          path: '/message',
          children: [
            {
              id: 4001,
              name: '列表',
              path: '/message/message',
              children: []
            },
            {
              id: 4002,
              name: '添加编辑',
              path: '/message/messageadd',
              children: []
            }
          ]
        },
        {
          id: 9,
          name: '宣传位管理',
          path: '/advertise',
          children: [
            {
              id: 4001,
              name: '宣传位列表',
              path: '/advertise/AdvertiseGroup',
              children: []
            },
            {
              id: 4002,
              name: '宣传位详情',
              path: '/advertise/AdvertiseDetail',
              children: []
            },
            {
              id: 4003,
              name: '宣传位内容',
              path: '/advertise/AdvertiseAddImg',
              children: []
            }
          ]
        },
        {
          id: 10,
          name: '视频下线管理',
          path: '/adminstrator/Ofline',
          children: []
        }
      ]
    }
  },
  methods: {
    handleOpen: function () {
      // console.log("aaaa");
    },
    getRightList: async function () {
      var res = await this.$http.get('/v1/role/htlist')
      var {code, message, data} = res.data
      if (code == 0) {
        this.rightList = data
        // console.log(this.rightList)
      } else if (code == 40100) {
        this.$message.error(message)
        this.$router.push('/login')
      } else if (code == -102) {
        this.$router.push({
          path: '/login',
          query: {
            backpath: true
          }

        })
        window.localStorage.removeItem('token')
        this.$message.error(message)
      } else {
        this.$message.error(message)
      }
    }
  },
  computed: {
    path: function () {
      // 得到当前路由
      return this.$route.path
    }
  },
  mounted: function () {
    this.getRightList()
  }
}
</script>

<style scoped lang="scss">
/* 侧边栏样式 */
a {
  text-decoration: none;
  // color: black;
}
.el-submenu {
  // border-bottom: 1px solid #f8f8f8;
}
.menu-first-link {
  font-size: 16px;
  font-weight: 400;
  // color: black;
  // border-bottom: 1px solid #f8f8f8;
}
.menu-second-link {
  display: inline-block;
  width: 100%;
  height: 100%;
  // color: #787878;
}
.el-menu-item.is-active {
  // border-left: 3px solid #f56c6c;
  border-right: 3px solid #409eff;
  a {
    // color: rgb(255, 208, 75);
    color:#409eff;
  }
}
.el-menu-item:hover {
  background-color: #fff;
}
.el-menu-vertical-demo {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar2.vue